var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar-nav',{attrs:{"data-qa":"main navigation"}},_vm._l((_vm.links),function(link,index){return _c('li',{key:index,staticClass:"nav-item"},[_c('SmartLink',{attrs:{"destination":link.url,"link-class":"nav-link btn btn-light-flat","exact":""}},[_vm._v("\n      "+_vm._s(link.text)+"\n    ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }